export enum ProjectType {
  HEDIS = 1,
  RISK = 2,
  IVA = 3,
  ADDRESS_VERIFICATION = 4,
  CHART_LAKE = 5,
  CHART_COLLECTION_ONLY = 6,
  MEMBER_MANAGEMENT = 7,
}
